import {
  Box,
  Center,
  CircularProgress,
  CircularProgressLabel,
  HStack,
  Spacer,
  Stack,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { BugIcon, ExclamationTriangleIcon } from 'components/icons';
import { ListItemMainText } from 'components/ListItem/ListItemMainText';
import { ListItemSecondaryText } from 'components/ListItem/ListItemSecondaryText';
import React from 'react';

export type UploadingHandleProps = {
  uploadName: string;
  uploadError?: string;
  isFailed: boolean;
} & UploadIconProps;

export const UploadingHandle = ({
  uploadName,
  isFailed,
  uploadError,
  ...iconProps
}: UploadingHandleProps) => {
  uploadError = uploadError || t`Upload failed`;
  return (
    <Box overflow="hidden" flexGrow={2}>
      <HStack spacing={2}>
        <HStack spacing={4} minWidth={0} flexGrow={1} whiteSpace="nowrap">
          <Box>
            <UploadIcon {...iconProps} isFailed={isFailed} />
          </Box>
          <Stack spacing={0} whiteSpace="nowrap" minWidth={0}>
            <ListItemMainText>{uploadName}</ListItemMainText>
            <ListItemSecondaryText>
              {isFailed ? uploadError : t`Uploading`}
            </ListItemSecondaryText>
          </Stack>
        </HStack>
        <Spacer />
      </HStack>
    </Box>
  );
};

type UploadIconProps = {
  isFailed: boolean;
  isVirus: boolean;
  loadingPercentage: number;
};

export const UploadIcon = ({
  isVirus,
  isFailed,
  loadingPercentage,
}: UploadIconProps) => {
  const variant = 'Large';
  const color = 'blue.500';

  if (isVirus) {
    return <BugIcon variant={variant} color={color} />;
  }
  if (isFailed) {
    return <ExclamationTriangleIcon variant={variant} color={color} />;
  }

  return (
    <Center height="48px" width="40px">
      <CircularProgress value={loadingPercentage} size="40px" color="blue.500">
        <CircularProgressLabel>{loadingPercentage}%</CircularProgressLabel>
      </CircularProgress>
    </Center>
  );
};
